import React, { lazy } from 'react';
import { WidgetSizes } from '@frontend/grid-dashboard';
import { stickyColors } from '@frontend/sticky-note-widget';
/**
 * ------------ AUTO GENERATED FILE ------------------
 *
 * Please don't manually update this file. Use ***pnpm run generate:widget-library-images***
 * that generates optimal svg components and populates this list automatically.
 */
type SVGComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
const lazyComponents: Record<string, React.LazyExoticComponent<SVGComponent>> = {};

const getLazyComponent = (componentName: string): React.LazyExoticComponent<SVGComponent> => {
  if (!lazyComponents[componentName]) {
    lazyComponents[componentName] = lazy(() =>
      import('./assets').then((module) => ({
        default: module[componentName as keyof typeof module],
      }))
    );
  }
  return lazyComponents[componentName];
};

type WidgetLibraryItem = {
  [key: string]: {
    [key in WidgetSizes]?: React.LazyExoticComponent<React.ComponentType<React.SVGProps<SVGSVGElement>>>;
  };
};

export const widgetLibraryImages: WidgetLibraryItem = {
  'classic-view': {
    'large-narrow': getLazyComponent('ClassicViewLNImage'), //AUTO-GENERATED
  },
  'add-message': {
    'tiny-slim': getLazyComponent('AddMessageTSImage'), //AUTO-GENERATED
  },
  'payments-summary': {
    'medium-narrow': getLazyComponent('PaymentsSummaryMNImage'), //AUTO-GENERATED
    'medium-wide': getLazyComponent('PaymentsSummaryMWImage'), //AUTO-GENERATED
  },
  'add-fax': {
    'tiny-slim': getLazyComponent('AddFaxTSImage'), //AUTO-GENERATED
    'large-wide': getLazyComponent('AddFaxLWImage'), //AUTO-GENERATED
  },
  'phones-snapshot-widget': {
    'medium-wide': getLazyComponent('PhonesSnapshotWidgetMWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('PhonesSnapshotWidgetLNImage'), //AUTO-GENERATED
  },
  'opportunity-list-widget': {
    'large-wide': getLazyComponent('OpportunityListWidgetLWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('OpportunityListWidgetLNImage'), //AUTO-GENERATED
  },
  'payments-24-hours': {
    'large-wide': getLazyComponent('Payments24HoursLWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('Payments24HoursLNImage'), //AUTO-GENERATED
  },
  'training-articles': {
    'large-narrow': getLazyComponent('TrainingArticlesLNImage'), //AUTO-GENERATED
  },
  'add-quick-fill': {
    'tiny-slim': getLazyComponent('AddQuickFillTSImage'), //AUTO-GENERATED
  },
  'confirmation-status-widget': {
    'medium-wide': getLazyComponent('ConfirmationStatusWidgetMWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('ConfirmationStatusWidgetLNImage'), //AUTO-GENERATED
  },
  'cancelled-patients': {
    'small-narrow': getLazyComponent('CancelledPatientsWidgetSNImage'), //AUTO-GENERATED
  },
  'hygiene-follow-ups-widget': {
    'small-narrow': getLazyComponent('HygieneFollowUpsWidgetSNImage'), //AUTO-GENERATED
  },
  'call-results-widget': {
    'medium-narrow': getLazyComponent('CallResultsWidgetMNImage'), //AUTO-GENERATED
  },
  'connection-status-widget': {
    'small-wide': getLazyComponent('ConnectionStatusWidgetSWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('ConnectionStatusWidgetLNImage'), //AUTO-GENERATED
  },
  'schedule-requests-widget': {
    'large-narrow': getLazyComponent('ScheduleRequestsWidgetLNImage'), //AUTO-GENERATED
  },
  'top-appointment-types-widget': {
    'small-wide': getLazyComponent('TopAppointmentTypesWidgetSWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('TopAppointmentTypesWidgetLNImage'), //AUTO-GENERATED
  },
  'quick-actions': {
    'medium-narrow': getLazyComponent('QuickActionsMNImage'), //AUTO-GENERATED
  },
  'unbooked-hours-widget': {
    'tiny-slim': getLazyComponent('UnbookedHoursWidgetTSImage'), //AUTO-GENERATED
  },
  'booked-hours-widget': {
    'tiny-slim': getLazyComponent('BookedHoursWidgetTSImage'), //AUTO-GENERATED
  },
  'appointment-count': {
    'tiny-slim': getLazyComponent('AppointmentCountTSImage'), //AUTO-GENERATED
  },
  'bulk-email-widget': {
    'small-narrow': getLazyComponent('BulkEmailWidgetSNImage'), //AUTO-GENERATED
    'small-wide': getLazyComponent('BulkEmailWidgetSWImage'), //AUTO-GENERATED
    'tiny-slim': getLazyComponent('BulkEmailWidgetTSImage'), //AUTO-GENERATED
  },
  'bulk-texting-widget': {
    'tiny-slim': getLazyComponent('BulkTextingWidgetTSImage'), //AUTO-GENERATED
    'small-wide': getLazyComponent('BulkTextingWidgetSWImage'), //AUTO-GENERATED
    'small-narrow': getLazyComponent('BulkTextingWidgetSNImage'), //AUTO-GENERATED
  },
  'cancelled-patients-widget': {
    'small-narrow': getLazyComponent('CancelledPatientsWidgetSNImage'), //AUTO-GENERATED
  },
  'appointments-widget': {
    'large-narrow': getLazyComponent('AppointmentsWidgetLNImage'), //AUTO-GENERATED
    'medium-wide': getLazyComponent('AppointmentsWidgetMWImage'), //AUTO-GENERATED
  },
  'add-invoice': {
    'tiny-slim': getLazyComponent('AddInvoiceTSImage'), //AUTO-GENERATED
  },
  'form-sent-comprehensive': {
    'large-wide': getLazyComponent('FormsSentComprehensiveLWImage'), //AUTO-GENERATED
    'medium-wide': getLazyComponent('FormsSentComprehensiveMWImage'), //AUTO-GENERATED
    'medium-narrow': getLazyComponent('FormsSentComprehensiveMNImage'), //AUTO-GENERATED
  },
  'forms-submission': {
    'small-narrow': getLazyComponent('FormsSubmissionSNImage'), //AUTO-GENERATED
    'tiny-slim': getLazyComponent('FormsSubmissionTSImage'), //AUTO-GENERATED
  },
  'forms-sent': {
    'small-narrow': getLazyComponent('FormsSentSNImage'), //AUTO-GENERATED
    'tiny-slim': getLazyComponent('FormsSentTSImage'), //AUTO-GENERATED
  },
  'forms-submission-comprehensive': {
    'large-wide': getLazyComponent('FormsSubmissionComprehensiveLWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('FormsSubmissionComprehensiveLNImage'), //AUTO-GENERATED
  },
  'missed-call-text-roi': {
    'tiny-slim': getLazyComponent('MissedCallTextRoiTSImage'), //AUTO-GENERATED //AUTO-GENERATED //AUTO-GENERATED
    'small-narrow': getLazyComponent('MissedCallTextRoiSNImage'), //AUTO-GENERATED
  },
  'unread-voicemails-widget': {
    'large-wide': getLazyComponent('UnreadVoicemailsWidgetLWImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('UnreadVoicemailsWidgetLNImage'), //AUTO-GENERATED
  },
  'sticky-note-yellow': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
  'sticky-note-purple': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
  'sticky-note-orange': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
  'sticky-note-green': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
  'sticky-note-blue': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
  'sticky-note-pink': {
    'medium-narrow': getLazyComponent('StickyNoteYellowMNImage'), //AUTO-GENERATED
    'large-narrow': getLazyComponent('StickyNoteYellowLNImage'), //AUTO-GENERATED
  },
};

export const customProps: Record<string, Record<string, any>> = {
  'sticky-note-yellow': {
    color: stickyColors['yellow'],
  },
  'sticky-note-orange': {
    color: stickyColors['orange'],
  },
  'sticky-note-green': {
    color: stickyColors['green'],
  },
  'sticky-note-blue': {
    color: stickyColors['blue'],
  },
  'sticky-note-purple': {
    color: stickyColors['purple'],
  },
  'sticky-note-pink': {
    color: stickyColors['pink'],
  },
};
